import { css } from '@emotion/core';
import { IThemeVariables } from './themeVariables';

const skinBg = (themeVariables: IThemeVariables) => ({
  accent: {
    default: css`
      background-color: ${themeVariables.colors.accent.default};
    `,
    disabled: css`
      background-color: ${themeVariables.colors.accent.disabled};
    `,
    light: css`
      background-color: ${themeVariables.colors.accent.light};
    `
  },
  action: {
    primary: {
      dark: css`
        background-color: ${themeVariables.colors.action.primary.dark};
      `,
      default: css`
        background-color: ${themeVariables.colors.action.primary.default};
      `,
      extraDark1: css`
        background-color: ${themeVariables.colors.action.primary.extraDark1};
      `,
      extraDark2: css`
        background-color: ${themeVariables.colors.action.primary.extraDark2};
      `,
      extraLight: css`
        background-color: ${themeVariables.colors.action.primary.extraLight};
      `,
      light: css`
        background-color: ${themeVariables.colors.action.primary.light};
      `
    },
    secondary: {
      default: css`
        background-color: ${themeVariables.colors.action.secondary.default};
      `,
      light: css`
        background-color: ${themeVariables.colors.action.secondary.light};
      `
    }
  },
  application: {
    background: css`
      background-color: ${themeVariables.colors.application.background};
    `,
    disabled: css`
      background-color: ${themeVariables.colors.application.disabled};
    `
  },
  element: {
    dark: css`
      background-color: ${themeVariables.colors.element.dark};
    `,
    default: css`
      background-color: ${themeVariables.colors.element.default};
    `,
    highlight: css`
      background-color: ${themeVariables.colors.element.highlight};
    `,
    light: css`
      background-color: ${themeVariables.colors.element.light};
    `
  },
  misc: {
    dark: css`
      background-color: ${themeVariables.colors.misc.dark};
    `,
    extraDark: css`
      background-color: ${themeVariables.colors.misc.extraDark};
    `,
    extraLight: css`
      background-color: ${themeVariables.colors.misc.extraLight};
    `,
    light: css`
      background-color: ${themeVariables.colors.misc.light};
    `,
    medium: css`
      background-color: ${themeVariables.colors.misc.medium};
    `,
    transparent: css`
      background-color: ${themeVariables.colors.misc.transparent};
    `,
    white: css`
      background-color: ${themeVariables.colors.misc.white};
    `
  },
  status: {
    negative: {
      default: css`
        background-color: ${themeVariables.colors.status.negative.default};
      `,
      light: css`
        background-color: ${themeVariables.colors.status.negative.light};
      `
    },
    neutral: {
      default: css`
        background-color: ${themeVariables.colors.status.neutral.default};
      `,
      light: css`
        background-color: ${themeVariables.colors.status.neutral.light};
      `
    },
    positive: {
      default: css`
        background-color: ${themeVariables.colors.status.positive.default};
      `,
      light: css`
        background-color: ${themeVariables.colors.status.positive.light};
      `
    },
    warning: {
      default: css`
        background-color: ${themeVariables.colors.status.warning.default};
      `,
      light: css`
        background-color: ${themeVariables.colors.status.warning.light};
      `
    }
  },
  table: {
    alt: css`
      background-color: ${themeVariables.colors.table.alt};
    `,
    highlight: css`
      background-color: ${themeVariables.colors.table.highlight};
    `
  }
});

const skinBorder = (themeVariables: IThemeVariables) => ({
  action: {
    primary: {
      dark: css`
        border-color: ${themeVariables.colors.action.primary.dark};
      `,
      default: css`
        border-color: ${themeVariables.colors.action.primary.default};
      `,
      extraDark1: css`
        border-color: ${themeVariables.colors.action.primary.extraDark1};
      `,
      extraDark2: css`
        border-color: ${themeVariables.colors.action.primary.extraDark2};
      `,
      extraLight: css`
        border-color: ${themeVariables.colors.action.primary.extraLight};
      `,
      light: css`
        border-color: ${themeVariables.colors.action.primary.light};
      `
    },
    secondary: {
      default: css`
        border-color: ${themeVariables.colors.action.secondary.default};
      `,
      light: css`
        border-color: ${themeVariables.colors.action.secondary.light};
      `
    }
  },
  application: {
    background: css`
      border-color: ${themeVariables.colors.application.background};
    `,
    disabled: css`
      border-color: ${themeVariables.colors.application.disabled};
    `
  },
  element: {
    dark: css`
      border-color: ${themeVariables.colors.element.dark};
    `,
    default: css`
      border-color: ${themeVariables.colors.element.default};
    `,
    highlight: css`
      background-color: ${themeVariables.colors.element.highlight};
    `,
    light: css`
      border-color: ${themeVariables.colors.element.light};
    `
  },
  misc: {
    dark: css`
      border-color: ${themeVariables.colors.misc.dark};
    `,
    extraDark: css`
      border-color: ${themeVariables.colors.misc.extraDark};
    `,
    extraLight: css`
      border-color: ${themeVariables.colors.misc.extraLight};
    `,
    light: css`
      border-color: ${themeVariables.colors.misc.light};
    `,
    medium: css`
      border-color: ${themeVariables.colors.misc.medium};
    `,
    transparent: css`
      border-color: ${themeVariables.colors.misc.transparent};
    `,
    white: css`
      border-color: ${themeVariables.colors.misc.white};
    `
  },
  status: {
    negative: {
      default: css`
        border-color: ${themeVariables.colors.status.negative.default};
      `,
      light: css`
        border-color: ${themeVariables.colors.status.negative.light};
      `
    },
    neutral: {
      default: css`
        border-color: ${themeVariables.colors.status.neutral.default};
      `,
      light: css`
        border-color: ${themeVariables.colors.status.neutral.light};
      `
    },
    positive: {
      default: css`
        border-color: ${themeVariables.colors.status.positive.default};
      `,
      light: css`
        border-color: ${themeVariables.colors.status.positive.light};
      `
    },
    warning: {
      default: css`
        border-color: ${themeVariables.colors.status.warning.default};
      `,
      light: css`
        border-color: ${themeVariables.colors.status.warning.light};
      `
    }
  },
  table: {
    alt: css`
      border-color: ${themeVariables.colors.table.alt};
    `,
    highlight: css`
      border-color: ${themeVariables.colors.table.highlight};
    `
  }
});

const skinOutline = (themeVariables: IThemeVariables) => ({
  action: {
    primary: {
      dark: css`
        outline-color: ${themeVariables.colors.action.primary.dark};
      `,
      default: css`
        outline-color: ${themeVariables.colors.action.primary.default};
      `,
      extraDark1: css`
        outline-color: ${themeVariables.colors.action.primary.extraDark1};
      `,
      extraDark2: css`
        outline-color: ${themeVariables.colors.action.primary.extraDark2};
      `,
      extraLight: css`
        outline-color: ${themeVariables.colors.action.primary.extraLight};
      `,
      light: css`
        outline-color: ${themeVariables.colors.action.primary.light};
      `
    },
    secondary: {
      default: css`
        outline-color: ${themeVariables.colors.action.secondary.default};
      `,
      light: css`
        outline-color: ${themeVariables.colors.action.secondary.light};
      `
    }
  },
  application: {
    background: css`
      outline-color: ${themeVariables.colors.application.background};
    `,
    disabled: css`
      outline-color: ${themeVariables.colors.application.disabled};
    `
  },
  element: {
    dark: css`
      outline-color: ${themeVariables.colors.element.dark};
    `,
    default: css`
      outline-color: ${themeVariables.colors.element.default};
    `,
    highlight: css`
      background-color: ${themeVariables.colors.element.highlight};
    `,
    light: css`
      outline-color: ${themeVariables.colors.element.light};
    `
  },
  misc: {
    dark: css`
      outline-color: ${themeVariables.colors.misc.dark};
    `,
    extraDark: css`
      outline-color: ${themeVariables.colors.misc.extraDark};
    `,
    extraLight: css`
      outline-color: ${themeVariables.colors.misc.extraLight};
    `,
    light: css`
      outline-color: ${themeVariables.colors.misc.light};
    `,
    medium: css`
      outline-color: ${themeVariables.colors.misc.medium};
    `,
    transparent: css`
      outline-color: ${themeVariables.colors.misc.transparent};
    `,
    white: css`
      outline-color: ${themeVariables.colors.misc.white};
    `
  },
  status: {
    negative: {
      default: css`
        outline-color: ${themeVariables.colors.status.negative.default};
      `,
      light: css`
        outline-color: ${themeVariables.colors.status.negative.light};
      `
    },
    neutral: {
      default: css`
        outline-color: ${themeVariables.colors.status.neutral.default};
      `,
      light: css`
        outline-color: ${themeVariables.colors.status.neutral.light};
      `
    },
    positive: {
      default: css`
        outline-color: ${themeVariables.colors.status.positive.default};
      `,
      light: css`
        outline-color: ${themeVariables.colors.status.positive.light};
      `
    },
    warning: {
      default: css`
        outline-color: ${themeVariables.colors.status.warning.default};
      `,
      light: css`
        outline-color: ${themeVariables.colors.status.warning.light};
      `
    }
  },
  table: {
    alt: css`
      outline-color: ${themeVariables.colors.table.alt};
    `,
    highlight: css`
      outline-color: ${themeVariables.colors.table.highlight};
    `
  }
});

const skinOpacity = {
  full: css`
    opacity: 1;
  `,
  half: css`
    opacity: 0.5;
  `,
  light: css`
    opacity: 0.25;
  `,
  none: css`
    opacity: 0;
  `,
  semi: css`
    opacity: 0.75;
  `
};

export interface ISkinVariables {
  bg: object;
  border: object;
  opacity: object;
  outline: object;
}

export const getSkinVariables = (
  variables: IThemeVariables
): ISkinVariables => ({
  bg: skinBg(variables),
  border: skinBorder(variables),
  opacity: skinOpacity,
  outline: skinOutline(variables)
});
